import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRejectStatuses, fetchStatuses, orderService } from "../../services/services";

// Initial State
const initialState = {
  isOrderUpdated: false,
  orderStatusData: [],
  isLoading: false,
  isError: false,
  errorMessage: "",
  statuses: [],
  isStatusesLoading: false,
};

// Async Thunk for updating order status
export const updateOrderStatusAsync = createAsyncThunk(
  "orderStatus/updateOrderStatus",
  async ({ orderId, status, reject_reason }) => {
    const response = await orderService(orderId, status, reject_reason);
    return response;
  }
);


// Async Thunk for fetching statuses
export const fetchStatusesAsync = createAsyncThunk(
  "orderStatus/fetchStatuses",
  async () => {
    const response = await fetchStatuses();
    return response;
  }
);

// Async Thunk for fetching statuses
export const fetchRejectStatusesAsync = createAsyncThunk(
  "orderStatus/fetchRejectStatuses",
  async (params) => {
    const response = await fetchRejectStatuses(params);
    return response;
  }
);

// Order Status Slice
const orderStatusSlice = createSlice({
  name: "orderStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Update Order Status
      .addCase(updateOrderStatusAsync.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(updateOrderStatusAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isOrderUpdated = true;
        state.orderStatusData = action.payload;
      })
      .addCase(updateOrderStatusAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.error.message;
      })
      // Fetch Statuses
      .addCase(fetchStatusesAsync.pending, (state) => {
        state.isStatusesLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchStatusesAsync.fulfilled, (state, action) => {
        state.isStatusesLoading = false;
        state.statuses = action.payload;
      })
      .addCase(fetchStatusesAsync.rejected, (state, action) => {
        state.isStatusesLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      // Fetch Reject Statuses
      .addCase(fetchRejectStatusesAsync.pending, (state) => {
        state.isStatusesLoading = true;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(fetchRejectStatusesAsync.fulfilled, (state, action) => {
        state.isStatusesLoading = false;
        state.rejectStatus = action.payload;
      })
      .addCase(fetchRejectStatusesAsync.rejected, (state, action) => {
        state.isStatusesLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

// Export reducer and actions
export default orderStatusSlice.reducer;
